<template>
    <div class="dashboard-panel">
        <div class="dashboard-panel-inner">
            <SwitchGroup as="div" class="">
                <SwitchLabel as="h3" class="heading" passive>
                    {{ t('dashboard.notify-sms') }}
                </SwitchLabel>
                <div class="mt-2 sm:flex sm:items-start sm:justify-between">
                    <div class="max-w-xl text-sm text-mute">
                        <SwitchDescription>
                            {{ t('dashboard.sms-info') }}
                        </SwitchDescription>
                    </div>
                    <div class="mt-5 flex flex-row sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center space-x-4 items-center">
                        <button type="button" @click="$emit('show', true)" class="rounded-md bg-green-600 text-white px-4 py-[2px] flex flex-row space-x-2 items-center justify-center">
                            <span class="font-bold text-sm ">Verify</span><span><CheckIcon class="h-4 w-4 text-white" aria-hidden="true"/></span>
                        </button>
                    </div>
                </div>
                <div class="mt-5 space-x-4 flex flex-row">
                    <p class="dark:text-white">{{ t('dashboard.enable') }}</p>
                    <Switch v-model="enabled"
                            :class="[enabled ? 'bg-green-500 focus:ring-green-500' : 'bg-gray-200 focus:ring-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2']">
                        <span aria-hidden="true" :class="[enabled ? 'translate-x-5' : 'translate-x-0', 'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']"/>
                    </Switch>
                </div>
            </SwitchGroup>
        </div>
    </div>
</template>

<script>
import {onMounted, ref, watch} from 'vue'
import {CheckIcon} from '@heroicons/vue/outline'
import {Switch, SwitchDescription, SwitchGroup, SwitchLabel} from '@headlessui/vue'
import {useI18n} from "vue-i18n";

export default {
    components: {
        CheckIcon,
        Switch,
        SwitchDescription,
        SwitchGroup,
        SwitchLabel,
    },
    setup(props, {emit}) {
        const {t} = useI18n()
        const enabled = ref(false)
        const current = ref(false)

        onMounted(async () => {
            const {data} = await axios.get('/settings');
            enabled.value = data.sms
            current.value = data.sms
        })

        watch(enabled, (newVal) => {
            if (newVal !== current.value) {
                update()
            }
        })

        const update = async () => {
            try {
                await axios.patch('/settings/sms', {sms: enabled.value})
                current.value = enabled.value;
            } catch (err) {

            }
        }

        return {
            t,
            enabled,
        }
    },
}
</script>
